import axios from 'axios';

async function ObtenerPrestador(prmIdPrestador: number) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_prestador"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "id_prestador": prmIdPrestador
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerPrestador;